// extracted by mini-css-extract-plugin
export var root = "index-module--root--37ecd flex items-center justify-center min-h-screen";